module.exports = __webpack_public_path__ + "img/4.06.thmb.7525849e.jpg";